import React from 'react'
import Image from 'next/image'
import { Anchor, Box, Button, Text, Space } from '@mantine/core'
import { config, AIRDROP_CONFIG } from '@/config'
import { TextHeading } from '@/components'
import { useMediumScreen } from '@/hooks'
import { AirdropContainer } from './shared'

import illustration from '@/images/airdrop-ineligible-illustration.svg'

const AirdropIneligible = () => {
  const { isMediumScreen } = useMediumScreen()

  return (
    <AirdropContainer>
      <Box
        sx={(t) => ({
          display: 'flex',
          flexDirection: isMediumScreen ? 'row' : 'column-reverse',
          flexWrap: isMediumScreen ? 'nowrap' : 'wrap',
          gap: isMediumScreen ? t.other.airdropWalletConnect.desktopGap : t.other.airdropWalletConnect.mobileGap,
          position: 'relative'
        })}>
        <Box sx={{ width: '100%', pointerEvents: 'none' }}>
          <Box
            sx={
              isMediumScreen
                ? { position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }
                : { textAlign: 'center' }
            }>
            <Image src={illustration} alt="Airdrop Illustration" />
          </Box>
        </Box>

        <Box
          sx={(t) => ({
            flexShrink: isMediumScreen ? 0 : 1,
            maxWidth: isMediumScreen ? t.other.airdropWalletConnect.contentMaxWidth : 'auto',
            width: '100%'
          })}>
          <TextHeading sx={(t) => ({ fontSize: t.other.airdropWalletConnect.headingFontSize })}>Oh no!</TextHeading>

          <Space h="md" />

          <Text size="md">
            You don't seem to be eligible for this airdrop. Follow us on Twitter to not miss out on any future events!
          </Text>

          <Space h="md" />

          <Button size="lg" radius="md" fullWidth component="a" href={config.links.twitter} target="_blank">
            Follow {config.links.twitterHandle}
          </Button>

          <Space h="md" />

          <Anchor href={AIRDROP_CONFIG.guideUrl} underline={false} target="_blank">
            <Text size="md" sx={(t) => ({ color: t.colors.gray[7] })}>
              Who qualifies for airdrop? &rarr;
            </Text>
          </Anchor>
        </Box>
      </Box>
    </AirdropContainer>
  )
}

export { AirdropIneligible }
